<ng-container [formGroup]="form">
    <div class="autocomplete-container form-control">
        @if (optionsLabel()) {
            <label
                appReactiveLabel
                formControlName="autocomplete"
                [for]="'autocomplete-' + id"
                [reactive]="!showFallbackInput()"
                >{{ optionsLabel() }}</label
            >
        }
        <ctrl-autocomplete
            formControlName="autocomplete"
            [inputId]="'autocomplete-' + id"
            [placeholder]="placeholder() | formLabel"
            [options]="options()"
            [filterFn]="filterFn"
            [selectOnBlur]="true"
            (blur)="onTouch?.()"
        ></ctrl-autocomplete>
    </div>
    @if (showFallbackInput()) {
        <div class="form-control sub-input">
            <label
                appReactiveLabel
                formControlName="fallback"
                [for]="'fallback-input-' + id"
                >{{ fallbackOptionLabel() | formLabel }}</label
            >
            <input
                required
                type="text"
                formControlName="fallback"
                [id]="'fallback-input-' + id"
                [placeholder]="fallbackOptionLabel() | formLabel"
                (blur)="onTouch()"
            />
        </div>
    }
</ng-container>
